import { isBC } from "../../../../utils/businessType.lib.js";
import { Settings } from "@nxt-costco-com/forge-icons";
import { Account } from "@nxt-costco-com/forge-icons/icons/Account";
import { AccountDetails } from "@nxt-costco-com/forge-icons/icons/AccountDetails";
import { Box } from "@nxt-costco-com/forge-icons/icons/Box";
import { Card } from "@nxt-costco-com/forge-icons/icons/Card";
import { CostcoPay } from "@nxt-costco-com/forge-icons/icons/CostcoPay";
import { CostcoWallet } from "@nxt-costco-com/forge-icons/icons/CostcoWallet";
import { Lists } from "@nxt-costco-com/forge-icons/icons/Lists";
import { LocationSpecific } from "@nxt-costco-com/forge-icons/icons/LocationSpecific";
import { PaymentMethods } from "@nxt-costco-com/forge-icons/icons/PaymentMethods";
import { Renew } from "@nxt-costco-com/forge-icons/icons/Renew";
import { SignOut } from "@nxt-costco-com/forge-icons/icons/SignOut";
import { Truck } from "@nxt-costco-com/forge-icons/icons/Truck";
import { DIGITAL_MEMBERSHIP_CARD_LABEL_KEY, COSTCO_PAY_LABEL_KEY, PAYMENT_METHODS_LABEL_KEY, COSTCO_WALLET_LABEL_KEY, RENEW_MEMBERSHIP_LABEL_KEY, BUSINESS_DETAILS_LABEL_KEY, SIGN_OUT_LABEL_KEY, PREFERENCES_LABEL_KEY, LISTS_LABEL_KEY, ADDRESS_BOOK_LABEL_KEY, SIGN_IN_AND_SECURITY_LABEL_KEY, ACCOUNT_DETAILS_LABEL_KEY, ORDERS_PURCHASES_LABEL_KEY, ACCOUNT_HOME_LABEL_KEY } from "../../AccountMenus/constants.js";
import { wc_member } from "../../../Chrome/BrowseContext/legacyCookieStorage.js";
const menuItemIconMap = {
  accountdetails: AccountDetails,
  accounthome: Account,
  addressbook: LocationSpecific,
  businessdetails: Truck,
  costcopay: CostcoPay,
  costcowallet: CostcoWallet,
  digitalmembershipcard: Card,
  lists: Lists,
  orderspurchases: Box,
  paymentmethods: PaymentMethods,
  preferences: Settings,
  renewmembership: Renew,
  signout: SignOut,
  signinandsecurity: AccountDetails
};
const getLinkConfig = (properties) => {
  var _a;
  const linkConfiguration = (_a = properties == null ? void 0 : properties.find(
    (property) => property["linkConfig"]
  )) == null ? void 0 : _a.linkConfig;
  return linkConfiguration;
};
const getMenuItems = ({
  memberStatus,
  moduleSettings,
  accountMenuOptions,
  appendedToId
}) => {
  var _a;
  const menuList = [];
  const hasMembershipNumber = Number.isInteger(
    memberStatus == null ? void 0 : memberStatus.membershipNumber
  );
  const hasVerifiedMembership = !!(memberStatus == null ? void 0 : memberStatus.verifiedMembership);
  const isBusinessMember = (memberStatus == null ? void 0 : memberStatus.membershipType) === "Business" || (memberStatus == null ? void 0 : memberStatus.membershipType) === "Complimentary Business" || (memberStatus == null ? void 0 : memberStatus.membershipType) === "Business Trial";
  const linkConfig = getLinkConfig(moduleSettings.properties);
  const isDisplayCostcoWallet = isDisplayCostcoWalletLink(
    (_a = linkConfig == null ? void 0 : linkConfig.costcowallet) == null ? void 0 : _a.siteControls
  );
  for (const option of accountMenuOptions) {
    switch (option) {
      case ACCOUNT_HOME_LABEL_KEY:
      case ORDERS_PURCHASES_LABEL_KEY:
      case ACCOUNT_DETAILS_LABEL_KEY:
      case SIGN_IN_AND_SECURITY_LABEL_KEY:
      case ADDRESS_BOOK_LABEL_KEY:
      case LISTS_LABEL_KEY:
      case PREFERENCES_LABEL_KEY:
      case SIGN_OUT_LABEL_KEY:
        menuList.push(option);
        break;
      case BUSINESS_DETAILS_LABEL_KEY:
        if ((linkConfig == null ? void 0 : linkConfig.businessdetails) && hasVerifiedMembership && isBusinessMember) {
          menuList.push(option);
        }
        break;
      case RENEW_MEMBERSHIP_LABEL_KEY:
        if (isBC() && (linkConfig == null ? void 0 : linkConfig.renewmembership)) {
          menuList.push(option);
        }
        break;
      case COSTCO_WALLET_LABEL_KEY:
        if (isDisplayCostcoWallet) {
          menuList.push(option);
        }
        break;
      case PAYMENT_METHODS_LABEL_KEY:
        if (!isDisplayCostcoWallet) {
          menuList.push(option);
        }
        break;
      case COSTCO_PAY_LABEL_KEY:
        if (linkConfig == null ? void 0 : linkConfig.costcopay) {
          menuList.push(option);
        }
        break;
      case DIGITAL_MEMBERSHIP_CARD_LABEL_KEY:
        if ((linkConfig == null ? void 0 : linkConfig.digitalmembershipcard) && hasMembershipNumber) {
          menuList.push(option);
        }
    }
  }
  const keyValueMap = moduleSettings.key_value.reduce(
    (acc, keyValue) => {
      acc[keyValue.key] = keyValue.value;
      return acc;
    },
    {}
  );
  const menuListItems = menuList.map((item) => {
    var _a2, _b, _c;
    return {
      icon: menuItemIconMap[item],
      id: `${item}_${appendedToId}`,
      classicMenuKey: ((_a2 = linkConfig == null ? void 0 : linkConfig[item]) == null ? void 0 : _a2.classicMenuKey) || "",
      modUrl: ((_b = linkConfig == null ? void 0 : linkConfig[item]) == null ? void 0 : _b.modUrl) || "",
      label: keyValueMap[item] || "",
      to: (_c = linkConfig == null ? void 0 : linkConfig[item]) == null ? void 0 : _c.url,
      isSignOutItem: item === SIGN_OUT_LABEL_KEY
    };
  });
  return menuListItems;
};
const isDisplayCostcoWalletLink = (siteDisplayControl) => {
  var _a, _b, _c;
  console.log({ siteDisplayControl });
  if (((_a = siteDisplayControl == null ? void 0 : siteDisplayControl.alwaysdisplay) == null ? void 0 : _a.find(
    (site) => site === process.env.SITE || site === process.env.NEXT_PUBLIC_SITE
  )) !== void 0) {
    return true;
  }
  if (((_b = siteDisplayControl == null ? void 0 : siteDisplayControl.conditionaldisplay) == null ? void 0 : _b.find(
    (site) => site === process.env.SITE || site === process.env.NEXT_PUBLIC_SITE
  )) !== void 0) {
    const membershipData = wc_member.read();
    if (!membershipData) {
      return false;
    }
    const decodedMembershipData = decodeURIComponent(membershipData);
    const decodedMembershipDataArr = decodedMembershipData.split(",");
    const isCostcoWalletEnabled = decodedMembershipDataArr[10] === "1";
    return isCostcoWalletEnabled;
  }
  if (((_c = siteDisplayControl == null ? void 0 : siteDisplayControl.nodisplay) == null ? void 0 : _c.find(
    (site) => site === process.env.SITE || site === process.env.NEXT_PUBLIC_SITE
  )) !== void 0) {
    return false;
  }
  return false;
};
export {
  getLinkConfig,
  getMenuItems,
  isDisplayCostcoWalletLink,
  menuItemIconMap
};
